var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("노선별 주간 연비 추이 (km)")]),(_vm.week.length)?_c('bar-chart',{attrs:{"chart-data":_vm.chartdata,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }